export enum UserPermission {
  ManageProjects = 'projects:manage',
  ViewProjects = 'projects:view',
  EditProjects = 'projects:edit',
  ViewProjectsPrelaunch = 'projects:view_prelaunch',
  ViewEditor = 'projects:editor:view',
  ViewNotepad = 'projects:notepad:view',
  EditTranslationsPrelaunch = 'projects:translations:edit_prelaunch',
  ManagePanels = 'panels:manage',
  ViewPanels = 'panels:view',
  ManageComments = 'comments:manage',
  ManageClientBriefPrelaunch = 'projects:client_brief:manage_prelaunch',
  ViewClientBriefPrelaunch = 'projects:client_brief:view_prelaunch',
  ManagePolls = 'polls:manage',
  ManageUsers = 'users:manage',
  ViewUsers = 'users:view',
  ViewUsage = 'usage:view',
  ViewResearchAssistant = 'research_assistant:view',
  ManageClients = 'clients:manage',
  ViewClients = 'clients:view',
  ManageSystemSettings = 'system-settings:manage',
  ViewSystemSettings = 'system-settings:view',
  ManagePrizeDraw = 'prize-draw:manage'
}
